import Vue from './vue-config'
import articleFilters from './components/articleFilters'

if (document.getElementById('article')) {
    new Vue({
        el: '#article',
        components: {
            articleFilters
        },
        data: {
            url: ''
        },
        methods: {
            doSearch(model) {
                var qs = []
                if (model.query != '') qs.push(`query=${model.query}`)
                if (model.catId != 0) qs.push(`catId=${model.catId}`)
                var qss = '?' + qs.join('&')
                window.location.href = this.url + qss
            },
        },
        mounted() {
            this.url = this.$el.dataset.rootUrl
            window.lazyLoad.update()
        }
    })
}